// Reusable country code options for dropdowns
export const countryCodeOptions = [
  { value: '+31', label: '🇳🇱 +31', country: 'Netherlands' },
  { value: '+43', label: '🇦🇹 +43', country: 'Austria' },
  { value: '+32', label: '🇧🇪 +32', country: 'Belgium' },
  { value: '+359', label: '🇧🇬 +359', country: 'Bulgaria' },
  { value: '+385', label: '🇭🇷 +385', country: 'Croatia' },
  { value: '+357', label: '🇨🇾 +357', country: 'Cyprus' },
  { value: '+420', label: '🇨🇿 +420', country: 'Czech Republic' },
  { value: '+45', label: '🇩🇰 +45', country: 'Denmark' },
  { value: '+372', label: '🇪🇪 +372', country: 'Estonia' },
  { value: '+358', label: '🇫🇮 +358', country: 'Finland' },
  { value: '+33', label: '🇫🇷 +33', country: 'France' },
  { value: '+49', label: '🇩🇪 +49', country: 'Germany' },
  { value: '+30', label: '🇬🇷 +30', country: 'Greece' },
  { value: '+36', label: '🇭🇺 +36', country: 'Hungary' },
  { value: '+354', label: '🇮🇸 +354', country: 'Iceland' },
  { value: '+353', label: '🇮🇪 +353', country: 'Ireland' },
  { value: '+39', label: '🇮🇹 +39', country: 'Italy' },
  { value: '+371', label: '🇱🇻 +371', country: 'Latvia' },
  { value: '+423', label: '🇱🇮 +423', country: 'Liechtenstein' },
  { value: '+370', label: '🇱🇹 +370', country: 'Lithuania' },
  { value: '+352', label: '🇱🇺 +352', country: 'Luxembourg' },
  { value: '+356', label: '🇲🇹 +356', country: 'Malta' },
  { value: '+373', label: '🇲🇩 +373', country: 'Moldova' },
  { value: '+377', label: '🇲🇨 +377', country: 'Monaco' },
  { value: '+382', label: '🇲🇪 +382', country: 'Montenegro' },
  { value: '+47', label: '🇳🇴 +47', country: 'Norway' },
  { value: '+48', label: '🇵🇱 +48', country: 'Poland' },
  { value: '+351', label: '🇵🇹 +351', country: 'Portugal' },
  { value: '+40', label: '🇷🇴 +40', country: 'Romania' },
  { value: '+378', label: '🇸🇲 +378', country: 'San Marino' },
  { value: '+381', label: '🇷🇸 +381', country: 'Serbia' },
  { value: '+421', label: '🇸🇰 +421', country: 'Slovakia' },
  { value: '+386', label: '🇸🇮 +386', country: 'Slovenia' },
  { value: '+34', label: '🇪🇸 +34', country: 'Spain' },
  { value: '+46', label: '🇸🇪 +46', country: 'Sweden' },
  { value: '+41', label: '🇨🇭 +41', country: 'Switzerland' },
  { value: '+44', label: '🇬🇧 +44', country: 'United Kingdom' },
  { value: '+379', label: '🇻🇦 +379', country: 'Vatican City' },
  { value: '+1', label: '🇺🇸 +1', country: 'United States' },
  { value: '+1', label: '🇨🇦 +1', country: 'Canada' },
];

export const CountryCodeSelect = ({ name, value, onChange, className = '' }) => {
  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      className={`w-30 rounded-r-none border border-r-0 border-gray-300 px-3 py-2 text-sm focus:border-rowing-500 focus:ring-rowing-500 ${className}`}
    >
      {countryCodeOptions.map((option) => (
        <option key={`${option.value}-${option.country}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
